/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Ereader Container
 *
 * @file EreaderContainer.jsx
 * @author Gladson Samuel S
 */

import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  useLocation,
  useHistory
} from 'react-router-dom';

// Components
import ProductContainer from '../products/ProductContainer';
import CourseContainer from '../courses/CourseContainer';

// Common
import {
  COURSE_ROUTES,
  HOME_ROUTE,
  PRODUCT_ROUTES
} from '../../common/constants';
import CommonUtils from '../../common/utils/CommonUtils';

const EreaderContainer = ({
  route = HOME_ROUTE,
  onUnmount = () => {},
  onMount = () => {},
  isDrawerOpen = false,
  closeQRCodeModal = () => {}
}) => {
  const location = useLocation();
  const history = useHistory();
  const courseRouteMatch = CommonUtils.getMatchedRoute(COURSE_ROUTES(route), location);
  const productRouteMatch = CommonUtils.getMatchedRoute(PRODUCT_ROUTES(route), location);

  const renderEreader = () => {
    const isCourseLaunch = courseRouteMatch?.isExact;
    const isProductLaunch = productRouteMatch?.isExact;
    const match = isCourseLaunch ? courseRouteMatch : productRouteMatch;

    if (!isCourseLaunch && !isProductLaunch) {
      return null;
    }

    const props = {
      match,
      location,
      history,
      isGlobalNavEnabled: true,
      isDrawerOpen,
      onMount,
      closeQRCodeModal
    };

    return (
      <div className="pplus-ereader-container">
        {isCourseLaunch ? <CourseContainer {...props} /> : <ProductContainer {...props} /> }
      </div>
    );
  };

  useEffect(() => () => {
    onUnmount();
  },
  []);

  return (
    <Fragment>
      {renderEreader()}
    </Fragment>
  );
};

EreaderContainer.defaultProps = {
  route: HOME_ROUTE,
  onUnmount: () => {},
  onMount: () => {},
  isDrawerOpen: false,
  closeQRCodeModal: () => {}
};

EreaderContainer.propTypes = {
  route: PropTypes.string,
  onUnmount: PropTypes.func,
  onMount: PropTypes.func,
  isDrawerOpen: PropTypes.bool,
  closeQRCodeModal: PropTypes.func
};

export default EreaderContainer;
